import React, { useEffect, useState, Fragment } from "react";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import moment from "moment";
import WrapperPerfilCompany from "../../components/Aplicant/WrapperPerfilCompany";
import { Url } from "../../utils/Url/Url";

function DetalleEvento() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [event, setEvent] = useState("");
  const [imgPortada, setimgPortada] = useState("");
  const [banner, setbanner] = useState(null);

  useEffect(() => {
    var event = location.state
   if(event!=null){
       setEvent(event)
   }
  }, []);

  const pp = { width: "146px", height: "138px" };
  const ppBanner = {
    width: "100%",
    height: "100%",
  };

  const cover = { background: "none" };

  return (
    <div id="coursesD" className="vacantes perfil-empresa">
      <div className="container">
        <div className="row">
          <div className="body-profile">
            <div className="profile__header">
              <div className="profile__header-container">
                <div className="profile__cover-photo">
                  <img
                    id="bannerPic"
                    src={event.coverImage}
                    className="no-cover-image"
                    alt="No cover photo"
                    style={ppBanner}
                  ></img>
                </div>
                <div className="profile__header-info">
                  <div className="profile__header-info-left">
                    <div className="profile__header-info-left-wrapper">
                      <div className="profile__header-info-photo box-imgCat">
                        <img
                          id="bannerPic"
                          src={event.image}
                          className="no-cover-image"
                          alt="No cover photo"
                          style={ppBanner}
                        ></img>
                      </div>
                      <div className="profile__header-info-description">
                        <div className="profile__header-info-description-name">
                          {event.name}
                        </div>
                        <div className="course__header-public-by">
                         
                         
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row vacancy__content">
          <div className="col-12 col-md-5">
            <div className="vacancy__sidebar bordered-box mt-0">
              <div className="bordered-box__header">
                <div className="bordered-box__header-title">Información</div>
              </div>
              <div className="course__sidebar-content">
                <ul>
                  <li>
                    <strong>Fecha Inicio:</strong>{" "}
                    <span>{moment(event.startDate).calendar()}</span>
                  </li>
                  <li>
                    <strong>Fecha Finalizacion:</strong>{" "}
                    <span>{moment(event.endDate).calendar()}</span>
                  </li>
                  <li>
                    <strong>Ubicación:</strong> <span>{event.place}</span>
                  </li>

                  <li>
                    <strong>Contacto:</strong>{" "}
                    <span>
                      {event.contactName + " " + event.contactPhone}
                    </span>
                  </li>
                  <li>
                    <strong>Url:</strong><a target="_blank" rel="noopener noreferrer" href={Url(event.website)}>{Url(event.website)} </a>
                  </li>

                </ul>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-7">
            <div className="bordered-box mt-0">
              <div className="bordered-box__header-title">
                Descripción del Evento
              </div>
              <p>{event.description}</p>
              <hr className="mt-5" />
            </div>
            {/*<div className="mt-4 bordered-box">
              <div className="course-box__header">Preguntas de Estudiantes</div>
              <div className="row">
                <div className="col-md-2">
                  <img src="assets/images/user.png" alt="" />
                </div>
                <div className="col-md-10">
                  <div className="userQ-box">
                    <p className="userName">Sebastian Lanuza</p>
                    <p className="msj">
                      Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
                      sed diam nonumy eirmod tempor invidunt ut labore et dolore
                      magna aliquyam erat, sed diam voluptua. At vero eos et
                      accusam et justo duo dolores et.
                    </p>
                    <p className="text-end public">Publicado: hace 2 días</p>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="offset-md-4 col-md-8">
                  <div className="userQ-box answ-box">
                    <p className="enterpName">
                      <img
                        src="assets/images/logo-empresa-pequena.jpg"
                        alt=""
                      />
                      BAC
                    </p>
                    <p className="msj">
                      Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
                      sed diam nonumy eirmod tempor invidunt ut labore et dolore
                      magna aliquyam erat, sed diam voluptua. At vero eos et
                      accusam et justo duo dolores et.
                    </p>
                    <p className="text-end public">Publicado: hace 2 días</p>
                  </div>
                </div>
              </div>
              <div className="textAreaQ mb-3">
                <label for="exampleFormControlTextarea1" className="form-label">
                  Preguntanos
                </label>
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  placeholder="Escribi tu pregunta..."
                ></textarea>
              </div>
              <div className="row">
                <div className="col-6">
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="inlineCheckbox1"
                      value="option1"
                      checked=""
                    />
                    <label className="form-check-label" for="inlineCheckbox1">
                      ENVIAR DE FORMA PRIVADA
                    </label>
                  </div>
                </div>
                <div className="col-6">
                  <div className="profile__header-info-right-wrapper">
                    <div className="profile__header-info-right-button justify-content-end">
                      <a
                        href="#"
                        className="btn btn--gradient btn--gradient-small"
                      >
                        Enviar
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>*/}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetalleEvento;
